var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _circle4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstruments02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 35.931,
    width: 7.31034,
    height: 16.4483,
    rx: 1.21839,
    fill: "#184037"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3564,
    y: 30.4484,
    width: 7.31034,
    height: 21.931,
    rx: 1.21839,
    fill: "#184037"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.7124,
    y: 33.4944,
    width: 7.31034,
    height: 18.8851,
    rx: 1.21839,
    fill: "#184037"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 42.0693,
    y: 26.7932,
    width: 7.31034,
    height: 25.5862,
    rx: 1.21839,
    fill: "#184037"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6554,
    cy: 25.8392,
    r: 2.13218,
    stroke: "#184037",
    strokeWidth: 1.82759
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0118,
    cy: 15.4827,
    r: 2.13218,
    stroke: "#184037",
    strokeWidth: 1.82759
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.3678,
    cy: 22.7933,
    r: 2.13218,
    stroke: "#184037",
    strokeWidth: 1.82759
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.7242,
    cy: 13.046,
    r: 2.13218,
    stroke: "#184037",
    strokeWidth: 1.82759
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4829 24.0114L23.1841 17.3102M26.8392 17.3102L33.2358 21.5746M37.1956 20.9654L43.8967 14.5688",
    stroke: "#184037",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstruments02);
export default __webpack_public_path__ + "static/media/instruments_02.ed27cd279364e63cb63e28a67af236e9.svg";
export { ForwardRef as ReactComponent };